import React from 'react'
import _ from 'underscore'
import NavbarSearchResultResource from './search_result_resource'

class NavbarSearchResult extends React.Component {

  onNameClick = () => {
    this.props.onNameClick(this.props.result)
  }

  onResourceClick = (resource) => {
    this.props.onResourceClick(this.props.result, resource)
  }

  render() {
    const customer = this.props.result.customer
    const resources = this.props.result.resources
    const { isHighlighted, onMouseEnter } = this.props

    const baseClass = 'flex items-center gap-3 px-3.5 py-3 border-b last:border-b-0 hover:bg-accent odd:bg-muted/40'
    const highlightClass = isHighlighted ? 'bg-accent border-l-[3px] border-l-primary pl-[11px]' : ''

    return (
      <div className={`${baseClass} ${highlightClass}`} onMouseEnter={onMouseEnter}>
        <img
          src={customer.profile_picture_url}
          alt=""
          className="w-8 h-8 rounded-full shrink-0 cursor-pointer object-cover"
          onClick={this.onNameClick}
        />
        <div className="flex-1 min-w-0">
          <div className="flex justify-between items-baseline gap-3">
            <span
              className="font-semibold text-primary cursor-pointer truncate hover:underline"
              onClick={this.onNameClick}
            >
              {customer.name}
            </span>
            <span className="text-[13px] text-muted-foreground truncate shrink-0">
              {customer.email_address} / {customer.mobile_number}
            </span>
          </div>
          {resources.length > 0 && (
            <div className="flex flex-wrap gap-1.5 mt-1.5">
              {_.map(resources, (resource) => (
                <NavbarSearchResultResource
                  key={`${resource.type}-${resource.id}`}
                  resource={resource}
                  onClick={this.onResourceClick}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default NavbarSearchResult
